// extracted by mini-css-extract-plugin
module.exports = {"avatarContainer":"Avatar_avatarContainer__xS7wB","childrenContainer":"Avatar_childrenContainer__FQCnK"};